module.exports = __webpack_public_path__ + "img/HUA_logo.0ea4fb32.svg";